import { useQuery } from 'react-query';
import { getCodePanelRevisions } from '@experiment-management-shared';
import { QueryConfig } from '@shared/api';
import { CodePanelRevision } from './types';

export default function usePythonPanelRevisions(
  {
    templateId
  }: {
    templateId: string;
  },
  config?: QueryConfig<CodePanelRevision[]>
) {
  return useQuery(
    ['code-panel-revisions', { templateId }],
    ({ signal }) => {
      const groupedCodePanelRevisions = getCodePanelRevisions(
        templateId,
        signal
      );
      return groupedCodePanelRevisions;
    },
    config
  );
}
